
import React from 'react';
import Header from '@/components/layout/Header';
import CompareContainer from '@/components/compare/CompareContainer';

const HeadToHead: React.FC = () => {
  return (
    <>
      <Header />
      <CompareContainer />
    </>
  );
};

export default HeadToHead;
